/** What the camera is looking at: the food, to ask the AI about, or the packet, for its code. */
export type CameraMode = 'food' | 'barcode'

/** Whichever the camera was last left looking at, kept for as long as the app is open. */
let lastMode: CameraMode = 'food'

/** What the camera opens looking at: the food, or whichever it was last left on. */
export function cameraMode(): CameraMode {
  return lastMode
}

export function keepCameraMode(mode: CameraMode): void {
  lastMode = mode
}

/** Back to the food, as a fresh start — for one test not to leave the next its camera. */
export function forgetCameraMode(): void {
  lastMode = 'food'
}
